import Holidays from 'date-holidays';

const hd = new Holidays();

function isWeekday(date) {
  const day = date.getDay();
  return day !== 0 && day !== 6;
}

function isUSHoliday(date) {
  return hd.isHoliday(date);
}

function addBusinessDays(date, days) {
    let result = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000); // adjust for timezone offset
    result.setUTCDate(result.getUTCDate() + days);
    while (!isWeekday(result) || isUSHoliday(result)) {
        result.setUTCDate(result.getUTCDate() + 1);
    }
    // console.log(`Adding ${days} total days to ${date} results in ${result}`);
    return result; 
}
function adjustDateIfSame(dateField1, dateField2, newDateFields) {
    if (newDateFields[dateField1].date === newDateFields[dateField2].date) {
        const newDate = addBusinessDays(new Date(newDateFields[dateField2].date), 1);
        newDateFields[dateField2].date = newDate.toISOString().split('T')[0];

        // Calculate dayOfWeek for the new date
        newDateFields[dateField2].dayOfWeek = newDate.toLocaleDateString('en-US', { weekday: 'long' });
    }
}

export function autoFillDates(days, formData, setFormData) {
    const acceptanceDateUTC = new Date(formData.dateFields.acceptance_deadline_date.date);
    const acceptanceDate = new Date(Date.UTC(
        acceptanceDateUTC.getUTCFullYear(),
        acceptanceDateUTC.getUTCMonth(),
        acceptanceDateUTC.getUTCDate(),
        acceptanceDateUTC.getUTCHours(),
        acceptanceDateUTC.getUTCMinutes(),
        acceptanceDateUTC.getUTCSeconds()
    ));
    const newDateFields = { 
        ...formData.dateFields, 
        time_deadline_to_send_contract: { date: '21:00:00', checked: false, scheduledWithVendor: false },
        possession_time: { date: '21:00:00', checked: false, scheduledWithVendor: false },
        acceptance_deadline_time: { date: '21:00:00', checked: false, scheduledWithVendor: false },
    };

    let daysMapping = {
        alternative_earnest_money_deadline:  {
            30: 2, 
            45: 4,
            60: 5,       
        },
        record_title_deadline: {
            30: 6,
            45: 8,
            60: 9,
        },
        record_title_objection_deadline: {
            30: 7,
            45: 9,
            60: 10,
        },
        off_record_title_deadline: {
            30: 6,
            45: 8,
            60: 9,
        },
        off_record_title_objection_deadline: {
            30: 7,
            45: 9,
            60: 10,
        },
        title_resolution_deadline: {
            30: 8,
            45: 12,
            60: 14,  
        },
        right_of_first_refusal_deadline: {
            30: 7,
            45: 11,
            60: 13,  
        },
        seller_property_disclosure_deadline: {
            30: 2,
            45: 3,
            60: 3,  
        },
        lead_based_paint_disclosure_deadline: {
            30: 2,
            45: 3,
            60: 3,
        },
        new_loan_application_deadline: {
            30: 2,
            45: 3,
            60: 3,
        },
        new_loan_terms_or_termination_deadline: {
            30: 3,
            45: 4,
            60: 4,  
        },
        new_loan_availability_deadline: {
            30: 25,
            45: 30,
            60: 50,  
        },
        buyers_credit_information_deadline: {
            30: 7,
            45: 9,
            60: 12,            
        },
        disapproval_of_buyers_credit_information_deadline: {
            30: 8,
            45: 10,
            60: 13,
        },
        existing_loan_deadline: {
            30: 7,
            45: 9,
            60: 12,
        },
        existing_loan_termination_deadline: {
            30: 10,
            45: 14,
            60: 18,
        },
        loan_transfer_approval_deadline: {
            30: 10,
            45: 14,
            60: 18,
        },
        seller_or_private_financing_deadline: {
            30: 10,
            45: 14,
            60: 18,
        },
        appraisal_deadline: {
            30: 21,
            45: 28,
            60: 35,
        },
        appraisal_objection_deadline: {
            30: 22,
            45: 29,
            60: 136,
        },
        appraisal_resolution_deadline: {
            30: 24,
            45: 32,
            60: 40,
        },
        new_ilc_or_new_survey_deadline: {
            30: 21,
            45: 28,
            60: 35,
        },
        new_ilc_or_new_survey_objection_deadline: {
            30: 22,
            45: 29,
            60: 136,
        },
        new_ilc_or_new_survey_resolution_deadline: {
            30: 24,
            45: 32,
            60: 40,
        },
        inspection_termination_deadline: {
            30: 11,
            45: 16,
            60: 20,
        },
        inspection_objection_deadline: {
            30: 12,
            45: 18,
            60: 22,
        },
        inspection_resolution_deadline: {
            30: 14,
            45: 20,
            60: 26,
        },
        property_insurance_termination_deadline: {
            30: 17,
            45: 24,
            60: 28,
        },
        due_diligence_documents_delivery_deadline: {
            30: 10,
            45: 14,
            60: 17,
        },
        due_diligence_documents_objection_deadline: {
            30: 13,
            45: 17,
            60: 21,
        },
        due_diligence_documents_resolution_deadline: {
            30: 14,
            45: 20,
            60: 24,
        },
        conditional_sale_deadline: {
            30: 24,
            45: 32,
            60: 40,
        },
        lead_based_paint_termination_deadline: {
            30: 10,
            45: 13,
            60: 17,
        },
        closing_date: {
            30: 30,
            45: 45,
            60: 60,
        },
        possession_date: {
            30: 31,
            45: 46,
            60: 61,
        },
        // acceptance_deadline_date: {

        // },
    }; 

    if (formData.isHOA === true) {
        daysMapping.association_document_deadline = {
          30: 6, 
          45: 8, 
          60: 9,
        }; 
        daysMapping.association_documents_termination_deadline = {
          30: 7,
          45: 9,
          60: 10,
        };
      } else {
        daysMapping.association_document_deadline = 'N/A';
        if (newDateFields.association_document_deadline) {
            newDateFields.association_document_deadline.dayOfWeek = '';
        }
        daysMapping.association_documents_termination_deadline = 'N/A';
        if (newDateFields.association_documents_termination_deadline) {
            newDateFields.association_documents_termination_deadline.dayOfWeek = '';
        }
      }
    
      if (formData.addWaterAndMineralDates === true) {
        daysMapping.mineral_rights_examination_deadline = {
          30: 6,
          45: 8,
          60: 9,
        };
        daysMapping.water_rights_examination_deadline = {
            30: 6, 
            45: 8, 
            60: 9,
          }; 
      } else {
        daysMapping.mineral_rights_examination_deadline = 'N/A';
        if (newDateFields.mineral_rights_examination_deadline) {
            newDateFields.mineral_rights_examination_deadline.dayOfWeek = '';
        }
        daysMapping.water_rights_examination_deadline = 'N/A';
        if (newDateFields.water_rights_examination_deadline) {
            newDateFields.water_rights_examination_deadline.dayOfWeek = '';
        }
      }

    if (acceptanceDate) {
        // const newDateFields = { 
        //     ...formData.dateFields, 
        //     time_deadline_to_send_contract: { date: '21:00:00', checked: false, scheduledWithVendor: false },
        //     possession_time: { date: '21:00:00', checked: false, scheduledWithVendor: false },
        //     acceptance_deadline_time: { date: '21:00:00', checked: false, scheduledWithVendor: false },
        // };

        for (const [field, mapping] of Object.entries(daysMapping)) {
            if (newDateFields[field] && typeof mapping === 'object') {
                const newDate = addBusinessDays(acceptanceDate, mapping[days]);
                newDateFields[field].date = addBusinessDays(acceptanceDate, mapping[days]).toISOString().split('T')[0];
        
                // Calculate dayOfWeek for the new date
                newDateFields[field].dayOfWeek = newDate.toLocaleDateString('en-US', { weekday: 'long' });
            } else if (newDateFields[field]) {
                newDateFields[field].date = 'N/A';
            }
        }

        // Adjust dates if they are the same
        adjustDateIfSame('record_title_deadline', 'record_title_objection_deadline', newDateFields);
        adjustDateIfSame('off_record_title_deadline', 'off_record_title_objection_deadline', newDateFields);
        adjustDateIfSame('new_loan_application_deadline', 'new_loan_terms_or_termination_deadline', newDateFields);
        adjustDateIfSame('buyers_credit_information_deadline', 'disapproval_of_buyers_credit_information_deadline', newDateFields);
        adjustDateIfSame('existing_loan_deadline', 'existing_loan_termination_deadline', newDateFields);
        adjustDateIfSame('appraisal_deadline', 'appraisal_objection_deadline', newDateFields);
        adjustDateIfSame('appraisal_objection_deadline', 'appraisal_resolution_deadline', newDateFields);
        adjustDateIfSame('new_ilc_or_new_survey_deadline', 'new_ilc_or_new_survey_objection_deadline', newDateFields);
        adjustDateIfSame('new_ilc_or_new_survey_objection_deadline', 'new_ilc_or_new_survey_resolution_deadline' ,newDateFields);
        adjustDateIfSame('inspection_termination_deadline', 'inspection_objection_deadline' ,newDateFields);
        adjustDateIfSame('inspection_objection_deadline', 'inspection_resolution_deadline' ,newDateFields);
        adjustDateIfSame('due_diligence_documents_objection_deadline', 'due_diligence_documents_resolution_deadline' ,newDateFields);
        
  
        setFormData(prevState => ({
            ...prevState,
            dateFields: newDateFields,
        }));
    }
  }